import {
  OvlAddScreen,
  OvlAddDialog,
} from "../../../../../../_ovlclient/src/global/globals"
import { DialogPKGPackagingSplit } from "../../features/pkgpackaging/packaging/packagingsplit/packagingsplit"
import { ScreenPackaging } from "./packaging/packaging"
import { ScreenPackagingCustomerChooser } from "./packagingcustomerchooser/packagingcustomerchooser"

export const PKGPackaging_Init = () => {
  OvlAddScreen(ScreenPackagingCustomerChooser, "PKGPackagingCustomerChooser")
  OvlAddScreen(ScreenPackaging, "PKGPackaging")
  OvlAddDialog(DialogPKGPackagingSplit, "PKGPackagingSplit")
}
